// extracted by mini-css-extract-plugin
module.exports = {"skeletonLoader":"profile-module-list_skeletonLoader__OKMCK"};